// @core/api/endpoints/subscription/check_entitlement.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CheckEntitlementResponse,
} from '../../../types/subscription';

const BASE_PATH = '/subscription';

/**
 * Check feature entitlement
 * Runtime check if a tenant has access to a specific feature. Fast path for feature gating in product code.
 */
export async function CheckEntitlement(
  tenant_id: string,
  options?: RequestOptions
): Promise<CheckEntitlementResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/tenants/:tenant_id/entitlements/check`;
  requestPath = requestPath.replace(':tenant_id', encodeURIComponent(tenant_id));
  const requestOptions = options;
  return client.get<CheckEntitlementResponse>(requestPath, { ...requestOptions });
}
